import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const sampleCopScan = api(async function sampleCopScan({ codeOfPracticeId, sampleSize }) {
    return mutate(
        gql`
            mutation SampleCopScan($codeOfPracticeId: ID!, $sampleSize: Int) {
                sampleCopScan(codeOfPracticeId: $codeOfPracticeId, sampleSize: $sampleSize)
            }
        `,
        { codeOfPracticeId, sampleSize },
        { returns: "sampleCopScan" }
    )
})
